var map = {
	"./views/base/category/index.vue": [
		3675,
		675
	],
	"./views/base/customer/index.vue": [
		3038,
		38
	],
	"./views/base/editProduct/index.vue": [
		4468,
		468
	],
	"./views/base/product/editProductSku/index.vue": [
		6282,
		282
	],
	"./views/base/product/index.vue": [
		5421,
		421
	],
	"./views/base/product/skuListAll/index.vue": [
		1148,
		148
	],
	"./views/base/productRecord/index.vue": [
		7992,
		992
	],
	"./views/base/shelveList/index.vue": [
		3154,
		154
	],
	"./views/base/shelvesLocation/index.vue": [
		115,
		115
	],
	"./views/base/spec/index.vue": [
		5530,
		530
	],
	"./views/base/specVal/index.vue": [
		9368,
		368
	],
	"./views/base/stockShelve/index.vue": [
		4753,
		753
	],
	"./views/base/supplier/index.vue": [
		3657,
		657
	],
	"./views/base/warehouse/index.vue": [
		2763,
		763
	],
	"./views/dashboard/index.vue": [
		4806,
		806
	],
	"./views/finance/payment/index.vue": [
		4513,
		513
	],
	"./views/finance/receipt/index.vue": [
		1595,
		595
	],
	"./views/finance/receiptReport/index.vue": [
		4317,
		317
	],
	"./views/login/index.vue": [
		3456,
		456
	],
	"./views/order/editSaleOrder/index.vue": [
		1542,
		927,
		542
	],
	"./views/order/saleOrder/index.vue": [
		3531,
		531
	],
	"./views/order/saleOrderDto/index.vue": [
		7376,
		733
	],
	"./views/stock/checkStock/index.vue": [
		5017,
		17
	],
	"./views/stock/checkStockDto/index.vue": [
		7943,
		969,
		943
	],
	"./views/stock/components/OrderTitle/index.vue": [
		5877,
		877
	],
	"./views/stock/inStock/index.vue": [
		4348,
		348
	],
	"./views/stock/inStockDto/index.vue": [
		4071,
		71
	],
	"./views/stock/inventory/index.vue": [
		7208,
		208
	],
	"./views/stock/inventoryDto/index.vue": [
		7792,
		792
	],
	"./views/stock/lossStock/index.vue": [
		6697,
		697
	],
	"./views/stock/lossStockDto/index.vue": [
		5577,
		969,
		577
	],
	"./views/stock/outStock/index.vue": [
		4779,
		779
	],
	"./views/stock/outStockDto/index.vue": [
		587,
		587
	],
	"./views/stock/returnStock/add/index.vue": [
		2048,
		927,
		48
	],
	"./views/stock/returnStock/index.vue": [
		4862,
		862
	],
	"./views/stock/returnStockDto/index.vue": [
		5644,
		644
	],
	"./views/stock/transferStock/index.vue": [
		1210,
		210
	],
	"./views/stock/transferStockDto/index.vue": [
		2567,
		567
	],
	"./views/system/menu/index.vue": [
		5062,
		62
	],
	"./views/system/role/index.vue": [
		8474,
		474
	],
	"./views/system/staff/index.vue": [
		1184,
		184
	],
	"./views/system/userCenter/index.vue": [
		3286,
		286
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2639;
module.exports = webpackAsyncContext;